<div class="container mt-5">
    <div class="grid">
        <div class="col-5">
            <div class="wrapper-block text-center wrapper-position p-5">
                <div class="result-title">
                    <h3 class="failure">Failure!</h3>
                    <p>Ooops, something went wrong.</p>
                </div>
                <!-- <div class="image-failure-container text-center">
                    <mat-icon>cancel</mat-icon>
                </div> -->
                <div class="pb-4 pt-5">
                    <button mat-raised-button color="warn" (click)="tryAgain()">Try Again</button>
                </div>
            </div>
        </div>
    </div>
</div>